import type { FaireProductEntity } from "../../entity_types/product";

export const p_y5tc8bza8a: FaireProductEntity = {
  token: "p_y5tc8bza8a",
  type: "product",
  name: "Rectangle Serving Board with Loop-Brown-9.5\"L",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl: "https://cdn.faire.com/fastly/9990a4bb5ff9479dac2efed0ebb6bab1b668d32312f7aad66a3ef3612b613f28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/616aba96b74512e92ec4aa2edc3f126c940dc67d2409ff48b8ae16d07fe90984.jpeg",
    "https://cdn.faire.com/fastly/2aacd8d7e7a0608e51d9b53f0e279a58c22c79f10dbde1c36d5d1d985eb5413b.jpeg",
    "https://cdn.faire.com/fastly/45b2e1c5d626ea20fcbfbe57b00e741511080cf25b3921c567dbf5ee01b61396.jpeg"
  ],
  priceDollars: 16.5,
  description: "Our Rectangle Serving Board with Loop features a cut-out handle and leather loop, adding a stylish touch. Crafted from solid marble, which is known for its durability, elegance, and natural cooling properties, this board is ideal for serving cheese, charcuterie, or desserts.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:14.783Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
